import { observable } from "mobx";
import { Type } from "class-transformer";
import ReportStatus from "./reportStatus";
import VehicleResponse from "./vehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class LustrationReportResponse {
  id!: string;

  @observable
  reportSequence!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicleRegistration!: VehicleResponse;

  @observable
  @Type(() => Date)
  eventOccurredAt!: Date;

  @observable
  @Type(() => Date)
  processedAt?: Date;

  @observable
  status!: ReportStatus;
}
